import { DECK_IDS, DECKS, type DeckId } from "../../shared/vocab";
import { SpeakerIcon } from "./SpeakerIcon";

type Props = {
  showSwitch: boolean;
  showAccount: boolean;
  showLeave: boolean;
  deckId: DeckId;
  onDeck: (id: DeckId) => void;
  user: string;
  onSignIn: () => void;
  onSignOut: () => void;
  onBattle: () => void;
  onLeave: () => void;
  canSpeak: boolean;
  muted: boolean;
  onToggleSound: () => void;
};

export function Header({
  showSwitch,
  showAccount,
  showLeave,
  deckId,
  onDeck,
  user,
  onSignIn,
  onSignOut,
  onBattle,
  onLeave,
  canSpeak,
  muted,
  onToggleSound,
}: Props) {
  return (
    <header className="header">
      <div className="brand">
        <div className="wordmark">
          Vocab<span>.</span>
        </div>
      </div>

      <div className="header-actions">
        {canSpeak && (
          <button
            type="button"
            className="btn btn-ghost btn-icon"
            onClick={onToggleSound}
            aria-pressed={!muted}
            aria-label={muted ? "Turn pronunciation on" : "Turn pronunciation off"}
            title={muted ? "Pronunciation off" : "Pronunciation on"}
          >
            <SpeakerIcon muted={muted} />
          </button>
        )}

        {showSwitch && (
          <div className="switch" role="group" aria-label="Deck">
            {DECK_IDS.map((id) => (
              <button
                key={id}
                type="button"
                aria-pressed={id === deckId}
                onClick={() => onDeck(id)}
              >
                {DECKS[id].label}
              </button>
            ))}
          </div>
        )}

        {showAccount &&
          (user ? (
            <div className="account">
              <span className="account-email" title={user}>
                {user}
              </span>
              <button type="button" onClick={onSignOut}>
                Sign out
              </button>
            </div>
          ) : (
            <button type="button" className="btn btn-ghost" onClick={onSignIn}>
              Sign in
            </button>
          ))}

        {showAccount && (
          <button type="button" className="btn btn-secondary btn-compact" onClick={onBattle}>
            Battle
          </button>
        )}

        {showLeave && (
          <button type="button" className="btn btn-ghost" onClick={onLeave}>
            Leave duel
          </button>
        )}
      </div>
    </header>
  );
}
